/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

import Task from './Task'

export default class Tasks {
    constructor() {
        this.tasks = [];
    }

    addTask(task) {
        var t = new Task(task)
        var index = this.tasks.indexOf(t)
        if (index = -1)
            this.tasks.push(t);
        else
            this.tasks[index] = t;
    }

    setTasks(tasks) {
        this.tasks = [];
        tasks.forEach(task => {
            this.addTask(task);
        });
    }

    get length() {
        return this.tasks.length;
    }

    get all() {
        return this.tasks;
    }

    find(taskId) {
        return this.tasks.find(task => task.taskId == taskId)
    }
}